var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPronunciatinoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_35)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#CA5050"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_309_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.739 415.691C482.098 340.166 482.263 195.965 386.739 120.309C382.114 116.645 375.393 117.426 371.73 122.052C368.067 126.678 368.846 133.397 373.472 137.061C458.04 204.04 458.17 331.858 373.472 398.94C368.843 402.606 368.069 409.326 371.73 413.949C375.394 418.575 382.114 419.355 386.739 415.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.103 169.195C343.478 165.529 336.758 166.308 333.093 170.932C329.427 175.559 330.207 182.278 334.831 185.942C387.823 227.934 387.92 307.987 334.831 350.057C330.206 353.723 329.428 360.442 333.093 365.066C336.758 369.691 343.478 370.47 348.103 366.804C411.894 316.255 411.991 219.821 348.103 169.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.469 218.053C304.842 214.391 298.123 215.172 294.46 219.8C290.798 224.427 291.579 231.146 296.207 234.808C317.62 251.757 317.656 284.213 296.207 301.19C291.579 304.853 290.797 311.571 294.46 316.199C298.123 320.826 304.842 321.607 309.469 317.946C341.685 292.448 341.736 243.593 309.469 218.053Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.523 418.203C137.504 412.051 161.516 411.207 171.711 409.766C178.109 408.852 189.605 407.902 194.527 402.559C203.492 392.855 204.09 383.504 203.105 375.242C202.051 366.629 200.293 358.332 203.527 353.129C205.18 350.492 212.141 337.203 203.809 333.934C199.379 332.176 196.496 333.758 178.039 334.391C169.461 334.672 162.922 331.402 165.734 326.762C168.863 323.211 182.258 321.699 194.844 317.059C203.738 313.789 208.414 311.785 209.434 304.121C210.066 299.48 206.691 296.738 204.969 290.973C203.387 285.734 204.898 283.344 207.043 281.234C210.312 278.035 218.961 272.867 220.121 263.445C222.055 247.344 195.195 239.047 186.371 222.348C182.152 214.367 185.738 192.676 185.738 185.609C185.738 156.992 171.43 109.039 126.219 81.6523C85.5781 57.043 34.6016 54.3008 -11.5234 65.832C-33.5664 71.3516 -55.9258 86.2578 -70.4453 99.3008C-105.145 130.449 -112.984 176.363 -115.516 192.816C-123.531 244.566 -109.539 284.152 -89.4649 315.934C-60.4609 361.883 -18.7305 391.52 -12.332 417.922C-11.3477 422.035 -10.5742 430.613 -10.5742 437.996C-10.5742 453.781 -11.4531 466.859 -12.3672 476.422H120.91C120.664 454.344 120.242 425.41 129.523 418.203V418.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 244,
    stroke: "#CA5050",
    strokeWidth: 24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 256,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_309_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "translate(489 118) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPronunciatinoIcon);
export default __webpack_public_path__ + "static/media/pronunciatino-icon.69dd3977e6a0eb3b14b0ef4bf81088ea.svg";
export { ForwardRef as ReactComponent };